import { gql } from '@apollo/client'

import { TaskTemplateFragment, TradeFragment } from '../fragments'

export const TRADES = gql`
  query trades {
    trades {
      ...TradeFragment
    }
  }
  ${TradeFragment}
`

export const TASK_TEMPLATES = gql`
  query taskTemplates($input: TaskTemplatesFindInput!) {
    taskTemplates(input: $input) {
      ...TaskTemplateFragment
    }
  }
  ${TaskTemplateFragment}
`

export const TASK_TEMPLATE = gql`
  query taskTemplate($id: ID!) {
    taskTemplate(id: $id) {
      ...TaskTemplateFragment
    }
  }
  ${TaskTemplateFragment}
`
